import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import icon from '@/shared/assets/icons/messages.svg';
export const ReviewsEmpty: React.FC = () => {
  const t = useTranslations();
  return <div className="flex flex-col items-center justify-center" data-sentry-component="ReviewsEmpty" data-sentry-source-file="ReviewsEmpty.tsx">
      <Image width={56} height={56} aria-hidden="true" alt="" src={`${icon}`} data-sentry-element="Image" data-sentry-source-file="ReviewsEmpty.tsx" />

      <p className="max-w-72 text-center text-base text-textSecondary">{t('doctor.reviews.empty')}</p>
    </div>;
};